import { Typography } from "@mui/material";
import { SERVER_API_PREFIX } from "../../constants";
import { MyButton } from "../MyButton";

export const OpencampLogin = () => {
  return (
    <MyButton
      component="a"
      href={`${SERVER_API_PREFIX}/login`}
      type="submit"
      sx={{ margin: 1 }}
    >
      <Typography
        sx={{
          fontWeight: 700
        }}
        variant="h6"
      >
        Prihlasit sa cez Opencamp
      </Typography>
    </MyButton>
  );
};
